/* eslint-disable */
import React from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {Link} from 'react-router-dom'
import Pageing from '../../Pagination/pageing'
import jMoment from 'moment-jalaali'
import http from '../../../Component/Interceptor/Interseptor'
import RETAIL from '../../BaseComponent/RETAIL'

export default class ReportDelivered extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      delivery: [],
      pageNumber: 1,
      pageSize: 50,
      progressing: false
    }
  }

  // componentDidUpdate(prevState, prevProps) {
  //   if (prevProps.currentPage !== this.props.currentPage) {
  //     this.setState({
  //       pageNumber: this.props.currentPage,
  //     });
  //   }
  // }

  componentDidMount() {
    this.setState({
      delivery: this.props.value
    })
  }

  convertState = (x, y) => {
    if (x == -100) {
      x = 'کنسل'
      // return x;
    } else if (x == -75) {
      x = 'مرجوعی'
      // return x;
    } else if (x == -50) {
      x = 'بازگشتی'
      // return x;
    } else if (x == 100) {
      x = 'تخصیص مجدد'
      // return x;
    } else if (x == -1) {
      x = 'تخصیص داده نشده'
      // return x;
    } else if (x === 1) {
      x = 'فعال'
      // return x;
    } else if (x == 5) {
      x = 'اول فعال'
      // return x;
    } else if (x == 10) {
      x = 'شروع شده'
      // return x;
    } else if (x == 18) {
      x = 'تسویه نشده'
      // return x;
    } else if (x == 20) {
      x = 'تسویه شده'
    }

    if (y) {
      y = 'تخصیص مجدد'
    } else {
      y = ''
    }

    return y == '' ? x : y + ' - ' + x
  }

  getPageNumber = (pageNumber) => {
    this.setState(
      {
        pageNumber
      },
      () => {
        this.props.refreshReport({
          pageNumber,
          pageSize: this.state.pageSize,
          sortBy: '',
          export: false
        })
      }
    )
  }

  confirmDelete = (item) => {
    this.setState({
      modalDelete: true,
      detailId: item.detailId
    })
  }

  delele = () => {
    this.setState({
      progressing: true
    })
    return http
      .post(`${RETAIL.RETAIL_MANAGE_DISPATCH_DETAIL_UNDOFINISH}`, {
        detailId: this.state.detailId
      })
      .then((res) => {
        this.setState({modalDelete: false, progressing: false})

        if (!res.data.error) {
          this.props.refreshReport({
            pageNumber: this.props.currentPage,
            pageSize: this.state.pageSize,
            sortBy: '',
            export: false
          })
        }
      })
      .catch(() => {
        this.setState({modalDelete: false, progressing: false})
      })
  }

  render() {
    const {value} = this.props
    return (
      <div>
        {value.length ? (
          <div>
            <table className="baseTable">
              <tbody>
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>تاریخ تحویل</td>
                  <td>بازه تحویل</td>
                  <td>زمان تحویل</td>
                  <td>شناسه فاکتور</td>
                  <td>آدرس</td>
                  {/* <td>شماره فاکتور</td> */}
                  <td> خریدار</td>
                  {/* <td> تحویل گیرنده</td> */}
                  {/* <td>موبایل</td> */}
                  <td>وضعیت پرداخت</td>
                  <td>پرداخت در محل</td>
                  <td>رساننده</td>
                  <td>کد اتومبیل</td>
                  <td>حالت</td>
                  <td>نوع تحویل</td>
                  <td>جزییات</td>
                  <td>حذف</td>
                </tr>
                {value.map((items, index) => (
                  <tr key={index}>
                    <td>{(this.props.currentPage - 1) * 50 + index + 1}</td>
                    <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                    <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                    <td>
                      {items.dispatchDate == null ? '-' : jMoment(items.dispatchDate).format('jYYYY/jM/jD HH:mm')}
                    </td>
                    <td>{items.invoice.invoiceId}</td>
                    <td>{items.invoice.address}</td>
                    {/* <td>{items.invoice.invoiceNum}</td> */}
                    <td>{items.invoice.buyerName}</td>

                    {/* <td>{items.invoice.recipientName}</td> */}
                    {/* <td className="mobileTD">
                  {items.invoice.mobile == null
                    ? "-"
                    : items.invoice.mobile.replace(/\+98/g, "0")}
                </td> */}
                    <td>{items.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                    <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                    <td title={items.driver == null ? '-' : items.driver.mobile.replace(/\+98/g, '0')}>
                      {items.driver == null ? '-' : items.driver.name}
                    </td>
                    <td>{items.car == null ? '-' : items.car.code}</td>
                    <td>{this.convertState(items.lastState, items.reAssigned)}</td>
                    <td>
                      {items.lastState == '20' && items.hasSign ? (
                        <button onClick={() => this.openSign(index)}>
                          <img
                            style={items.hasSign ? {display: 'block'} : {display: 'none'}}
                            src={require('../../../image/signature.svg')}
                          />
                        </button>
                      ) : items.lastState == '20' && !items.hasSign ? (
                        ' کد'
                      ) : (
                        '-'
                      )}
                    </td>
                    <td>
                      <Link
                        to={`/deliveryDetails/${items.deliveryPackId}/${items.invoice.invoiceNum}/${
                          items.invoice.invoiceId
                        }/${items.invoice.buyerName}/${items.detailId}`}
                        target="_blank"
                      >
                        <img src={require('../../../image/details.svg')} alt="" />
                      </Link>
                    </td>
                    <td>
                      <button onClick={() => this.confirmDelete(items)}>
                        <img src={require('../../../image/trash.svg')} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="paginationWrapp">
              <Pageing
                defaultCurrent={1}
                getPage={this.getPageNumber}
                pageSize={this.state.pageSize}
                currentPage={this.props.currentPage}
                total={this.props.total}
              />
            </div>
          </div>
        ) : null}

        <Modal
          isOpen={this.state.modalDelete}
          toggle={() => {
            this.setState({modalDelete: false})
          }}
          size="sm"
        >
          <ModalHeader toggle={this.deleteToggle}>حذف</ModalHeader>
          <ModalBody>
            <div className="text-center h5 font-weight-bold">
              <p>آیا از حذف مطمئن هستید؟؟؟</p>
            </div>
          </ModalBody>
          <ModalFooter>
            <button disabled={this.state.progressing} className="confirmBtnModal" onClick={this.delele}>
              حذف
            </button>
            <button
              className="cancelBtnModal"
              onClick={() => {
                this.setState({modalDelete: false})
              }}
            >
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
